import './index.scss';
import Header from '../../../../../../../components/Header/Header';
import NoData from '../../../../../../../components/NoData/NoData';
import { useState } from 'react';
import { formatToDollar } from '../../../../../../../helpers/utils';
import failureIcon from '../../../../../../../assets/icons/failureIcon.svg';
import successIcon from '../../../../../../../assets/icons/succesIcon.svg';
import dayjs from 'dayjs';

// import updateMemo from '../../../../../../../assets/icons/updateMemo.svg';
// import trashIcon from '../../../../../../../assets/icons/trashr.svg';
// import reverseIcon from '../../../../../../../assets/icons/reverseTransactions.svg';
// import Dropdown from '../../../../../../../components/Dropdown/Dropdown';
import useFlexDollar from '../../../../../../../hooks/useFlexDollar';
import ModalDeleteTransaction from '../../../../../../../components/Modals/ModalDeleteTransaction';
import ModalUpdateTransactionMemo from '../../../../../../../components/Modals/ModalUpdateTransactionMemo';
import FlexDollarTransactionDetails from '../../../../../../../components/NewSideSheet/FlexDollarTransactionDetails';
import useTransaction from '../../../../../../../hooks/useTransaction';
import { Loader } from '@piggytechng/component-library';

const index = () => {
  const { flexDollarTransactionQ, isLoadingFlexDollarTransactions, refetchFlexDollarTransactions } = useFlexDollar();
  const { deleteTransaction, updateTransactionMemo, isLoading: isTransactionLoading } = useTransaction();
  const [show, setShow] = useState(false);
  const [trDetails, setTrDetails] = useState<any>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTransactionRef, setSelectedTransactionRef] = useState<string>(''); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [showUpdateMemoModal, setShowUpdateMemoModal] = useState(false);
  const [selectedTransactionForMemo] = useState<{ reference: string; memo: string }>({
    // eslint-disable-line @typescript-eslint/no-unused-vars
    reference: '',
    memo: '',
  });
  // const [showDropdown, setShowDropdown] = useState({
  //   index: -1,
  //   show: false,
  // });

  // const dropdownRef = useRef(null);
  // const actionRef = useRef(null);
  // useOutsideClick(dropdownRef, setShowDropdown, actionRef);

  // const handleDeleteTransaction = (reference: string) => {
  //   setSelectedTransactionRef(reference);
  //   setShowDeleteModal(true);
  // };

  const handleDeleteSuccess = () => {
    refetchFlexDollarTransactions();
  };

  // const handleUpdateMemo = (reference: string, currentMemo: string) => {
  //   setSelectedTransactionForMemo({ reference, memo: currentMemo });
  //   setShowUpdateMemoModal(true);
  // };

  const handleUpdateMemoSuccess = () => {
    refetchFlexDollarTransactions();
  };

  const handleShowTransactionsDetails = (data: any) => {
    setTrDetails(data);
    setShow(true);
  };

  // const handleShowDropdown = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, i: number) => {
  //   e.stopPropagation();
  //   if (i === showDropdown.index) {
  //     setShowDropdown({ ...showDropdown, show: false, index: -1 });
  //   } else {
  //     setShowDropdown({ ...showDropdown, show: true, index: i });
  //   }
  // };

  // const getDropdownArray = (reference: string, currentMemo: string) => [
  //   {
  //     icon: updateMemo,
  //     text: 'Update memo',
  //     fn: () => handleUpdateMemo(reference, currentMemo),
  //   },
  //   {
  //     icon: trashIcon,
  //     text: 'Delete transaction',
  //     fn: () => handleDeleteTransaction(reference),
  //   },
  //   {
  //     icon: reverseIcon,
  //     text: 'Reverse transaction',
  //     fn: () => console.log('run'),
  //   },
  // ];

  return (
    <div className="view-all-flexnaira">
      <Header name={'Flex Dollar Transactions'} backButton />

      <div className="content">
        <div className="customers-filter">
          <div className="input-field">
            <form action="" onSubmit={() => {}}>
              <input
                type="text"
                placeholder="Search by Transaction ID, date"
                // value={searchForm.query}
                // onChange={(e) => {
                //   handleChange(e);
                // }}
              />
            </form>
          </div>
          <div className="query-filter">
            <div>
              <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                  stroke="#1E293B"
                  strokeWidth="1.5"
                  strokeLinecap="square"
                />
              </svg>
            </div>
            <div>Search</div>
          </div>
          <div
            className="query-filter"
            //  onClick={() => clearFilter()}
          >
            <div></div>
            <div>Reset</div>
          </div>
        </div>

        {isLoadingFlexDollarTransactions ? (
          <div className="page-loader">
            <Loader color="#0F60D6" />
          </div>
        ) : (
          <>
            {flexDollarTransactionQ?.length ? (
              <div className="table-container flexnaira">
                <table className="table">
                  <thead className="table_head">
                    <tr>
                      <th className="icon">{''}</th>
                      <th className="date">Date</th>
                      <th className="amount">{`Amount ($)`}</th>
                      <th className="balance">{`Balance ($)`}</th>
                      <th className="memo">Memo</th>
                      <th className="trID">Transaction ID</th>
                    </tr>
                  </thead>

                  <tbody className="table-body">
                    {flexDollarTransactionQ?.map((txn: any) => {
                      return (
                        <tr
                          key={txn.transactionId}
                          className="table-row"
                          onClick={() => handleShowTransactionsDetails(txn)}
                        >
                          <td className="icon">
                            <img
                              src={Number(txn.amount) >= 0 ? successIcon : failureIcon}
                              alt={Number(txn.amount) >= 0 ? 'credit' : 'debit'}
                            />
                          </td>
                          <td className="date">{dayjs(txn.date * 1000).format('D MMM YYYY | h:mm A')}</td>
                          <td className="amount">{formatToDollar(txn.amount)}</td>
                          <td className="balance">{formatToDollar(txn.balance)}</td>
                          <td className="memo">{txn.memo}</td>
                          <td className="trID">{txn.transactionId}</td>
                          {/* <div className="dropdown-container" ref={actionRef}>
                            <button onClick={(e) => handleShowDropdown(e, i)} className="pointer">
                              <LuMoreVertical color="#CBD5E1" size={25} />
                            </button>

                            {showDropdown.index === i && showDropdown.show && (
                              <div className="table-dropdown" ref={dropdownRef}>
                                <Dropdown data={getDropdownArray(txn.transactionId, txn.memo || '')} index={i} />
                              </div>
                            )}
                          </div> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <NoData message={'No transaction at the moment.'} />
            )}
          </>
        )}
      </div>

      <FlexDollarTransactionDetails
        show={show}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />

      {selectedTransactionRef && (
        <ModalDeleteTransaction
          modalIsOpen={showDeleteModal}
          setIsOpen={setShowDeleteModal}
          reference={selectedTransactionRef}
          wallet="flexdollar"
          onDelete={deleteTransaction}
          onSuccess={handleDeleteSuccess}
          isLoading={isTransactionLoading}
        />
      )}
      {selectedTransactionForMemo.reference && (
        <ModalUpdateTransactionMemo
          modalIsOpen={showUpdateMemoModal}
          setIsOpen={setShowUpdateMemoModal}
          reference={selectedTransactionForMemo.reference}
          wallet="flexdollar"
          currentMemo={selectedTransactionForMemo.memo}
          onUpdate={updateTransactionMemo}
          onSuccess={handleUpdateMemoSuccess}
          isLoading={isTransactionLoading}
        />
      )}
    </div>
  );
};

export default index;
